module.exports = __webpack_public_path__ + "assets/img/Mail1.1d47bfc4.png";